/* Verdure — theme bootstrap (ES module).
   Intentionally minimal: there is no monolithic core file. Each interactive
   custom element ships in its own module and self-registers when imported.
   Modules are added per build phase (header, rails, cart, search, …). */

// Global chrome
import './reveal-header.js';
import './nav-drawer.js';

// Shared interactive components
import './scroll-rail.js';
import './hover-video.js';

// Storefront / commerce
import './filter-form.js';
import './qty-stepper.js';
import './add-to-cart.js';
import './flyout-cart.js';
import './option-selector.js';
import './search-suggest.js';
